import FootballState from "../../../../football/state/football-state";
import Rule from "../../../../common/rule";

export default class FlagPatComplete extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            fragment.associatedState === FootballState.PatCompleted
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const patTryFragment = play.getFirstFragment(FootballState.PatTry);

        gameContext.increaseTeamPossessionScore(
            patTryFragment.getScoringPoints()
        );
        ruleContext.playPoints = patTryFragment.getScoringPoints();
        gameContext.switchPossession();
    }
}
